var exports = {
  "vK": "xe30f6088--78521a--banner",
  "Sd": "xe30f6088--78521a--banner--redesign",
  "NJ": "xe30f6088--78521a--banner-main-page-redesign",
  "Sl": "xe30f6088--78521a--image",
  "NN": "xe30f6088--78521a--image--redesign",
  "pJ": "xe30f6088--78521a--download-text",
  "nf": "xe30f6088--78521a--link",
};

module.exports = exports;
